<template>
	<a href="/discover/myDiscovery.html" :class="current" :data-scp="scp">
		<i class="icon icon-member"></i><span>我的</span><sub v-if="getNew"></sub>
	</a>
</template>

<script>
	export default {
		props: ['scp', 'current']
	}
</script>